import {Component, Inject} from '@angular/core';
import {InsightPopupService} from '../insight-popup.service';
import {Observable} from 'rxjs';
import {filter, switchMap, tap} from 'rxjs/operators';
import {
    LEARNING_PROGRESS_INSIGHT,
    LearningProgressInsightService
} from '../../../../services/LearningProgressInsightService';
import {LearningPackageInsightsTopicsResponseDto} from '../../../../services/rest/api-types/LearningPackageInsightsTopicsResponseDto';

@Component({
    selector: 'mm-topics-insight-popup',
    templateUrl: './topics-insight-popup.component.html',
    styleUrl: './topics-insight-popup.component.scss',
    standalone: false
})
export class TopicsInsightPopupComponent {

    constructor(public insightPopupService: InsightPopupService,
                @Inject(LEARNING_PROGRESS_INSIGHT) private learningProgressInsightService: LearningProgressInsightService) {
    }

    public size = 250;
    public strokeWidth = 1.5;
    public totalElements!: number;
    public elementsPerLine!: number;
    public squareWidth!: number;
    public topics: {name: string; mastery: number}[] = [];

    public levels1 = Array.from({length: 20}, (_, i) => i + 1);
    public colors = this.levels1.map(level => {
        const hue = (level / this.levels1.length) * 120;
        return `hsl(${hue}, 75%, 50%)`;
    });

    public topicsOverview$: Observable<LearningPackageInsightsTopicsResponseDto> = this.insightPopupService.selectedLearningPackageId$.pipe(
        filter((learningPackageId): learningPackageId is string => learningPackageId !== undefined),
        switchMap((learningPackageId: string) => this.learningProgressInsightService.getLearningProgressInsightTopicsOverview(learningPackageId)),
        tap(overview => {
            this.topics = overview.topics;
            this.totalElements = this.topics.length;
            this.elementsPerLine = this.calculateNextSquareNumber(this.totalElements);
            this.squareWidth = this.calculateSquareWidth(
                this.size,
                this.elementsPerLine,
                this.strokeWidth
            );
        })
    );

    public calculateNextSquareNumber(n: number): number {
        return Math.floor(Math.sqrt(n)) + 1;
    }

    public calculateSquareWidth(
        fullSize: number,
        elementsPerLine: number,
        strokeWidth: number
    ): number {
        const realStrokeWidth = strokeWidth / 2;
        return (
            (fullSize - elementsPerLine * realStrokeWidth - realStrokeWidth) / elementsPerLine
        );
    }

    public calculateXPosition(index: number): number {
        return this.strokeWidth / 2 + (this.squareWidth + this.strokeWidth / 2) * (index % this.elementsPerLine);
    }

    public calculateYPosition(index: number): number {
        return (
            this.strokeWidth / 2 + (this.squareWidth + this.strokeWidth / 2) *
            ((index - (index % this.elementsPerLine)) / this.elementsPerLine)
        );
    }

    public calculateBackgroundColor(mastery: number): string {
        return `hsl(${mastery * 120}, 75%, 50%)`;
    }

    public calculateTitle(topic: {name: string; mastery: number}): string {
        const percentage = Math.round(topic.mastery * 100);
        return `${topic.name} — ${percentage}%`;
    }
}
